module.exports = __webpack_public_path__ + "img/samsung_icon.f2fc4f7b.png";